import { FilterCheckIcon } from './FilterCheckIcon';

/**
 * author: Michael Irigoyen
 * id 176E2D7F-C16A-4941-9A42-3DBE264E4148
 * name filter-check
 * version: 6.3.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/filter-check.svg
 * tags
 */
export const FunnelCheckIcon = FilterCheckIcon;
export default FunnelCheckIcon